import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, ReplaySubject } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { User } from 'app/core/user/user.types';
import { LocalStorageService } from "../../services/local-storage.service";
import { environment } from "../../../environments/environment";
import { UserDef } from '../auth/models/auth-user';

@Injectable({
    providedIn: 'root'
})
export class UserService {
    private _user: ReplaySubject<UserDef> = new ReplaySubject<UserDef>(1);
    role: any;

    /**
     * Constructor
     */
    constructor(private _httpClient: HttpClient,
        private localstorageService: LocalStorageService) {
    }
    private saveUserToLocalStorage(user: UserDef): void {
        this.localstorageService.setItem(environment.common.storageKeys.authData, user);
    }


    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Setter & getter for user
     *
     * @param value
     */
    set user(value: UserDef) {
        // Store the value
        this.saveUserToLocalStorage(value);

        this._user.next(value);
    }

    get user$(): Observable<UserDef> {
        return this._user.asObservable();
    }

    get userData() {
        return this.localstorageService.getItem(environment.common.storageKeys.authData);
    }

    getGoogleUser() {
        const currentUser = this.localstorageService.getItem(environment.common.storageKeys.authData);

        if (currentUser) {

            return of(currentUser)
                .pipe(
                    tap((user) => {
                        this.user = user;
                        // this.getUserSubscription()

                        // this.role$.next(user.role)

                    })
                );
        } else {
            return of(null)
        }
    }

    updateUserNdaSigned(token, ndaSigned) {

        return this._httpClient.put(`user/profile/nda-signed`, { token, ndaSigned });
    }
}
